import { createFileRoute } from '@tanstack/react-router';
import { SmsTestPage } from '@/pages/sms/test/SmsTestPage';

/**
 * SMS scheduling agent test tool — visit by URL (/sms/test); not linked from
 * the menu (dev-tool convention).
 *
 * Starts a REAL outbound scheduling conversation for the current tenant and
 * books a real appointment. TODO: replace the implicit PATIENTS_VIEW gate on the
 * API with a dedicated DEV_TOOLS permission before rolling beyond internal
 * testers — tracked with the browser-call test tool.
 */
export const Route = createFileRoute('/_authenticated/sms/test')({
  component: SmsTestPage,
});
